import { displayChannelConstants } from './displayChannelConstants';
import {userConstants} from "../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  total: 0,
  error: '',
  query: "",
  resourceId: null,
  exactFields: null,
  exactValues: null,
  inProgress: true,
});

export function displayChannels(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case displayChannelConstants.DISPLAY_CHANNEL_LIST_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        inProgress: true,
      };
    case displayChannelConstants.DISPLAY_CHANNEL_LIST_SUCCESS:
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.displayChannels && action.displayChannels.display_channels ? action.displayChannels.display_channels : [],
        total: action.displayChannels && action.displayChannels.count ? action.displayChannels.count : 0,
        inProgress: false,
      };
    case displayChannelConstants.DISPLAY_CHANNEL_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case displayChannelConstants.DISPLAY_CHANNEL_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case displayChannelConstants.DISPLAY_CHANNEL_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.resourceId !== action.pagination.resourceId
        || state.exactFields !== action.pagination.exactFields
        || state.exactValues !== action.pagination.exactValues
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        resourceId: action.pagination.resourceId,
        exactFields: action.pagination.exactFields,
        exactValues: action.pagination.exactValues,
        shouldReload
      };
    }

    case displayChannelConstants.DISPLAY_CHANNEL_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case displayChannelConstants.DISPLAY_CHANNEL_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.displayChannel],
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(t => t.id === action.displayChannel.id ? action.displayChannel : t)
      }
    case displayChannelConstants.DISPLAY_CHANNEL_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }

    default:
      return state
  }
}
